// import React, { useState, useEffect } from 'react';
// import Box from '@mui/material/Box';
// import Typography from '@mui/material/Typography';
// import Modal from '@mui/material/Modal';
// import TextField from '@mui/material/TextField';
// import Grid from '@mui/material/Grid';
// import axios from 'axios';
// import Loader from '../common/Loader';
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';

// const style = {
//   position: 'absolute',
//   top: '50%',
//   left: '50%',
//   transform: 'translate(-50%, -50%)',
//   width: '90%',
//   maxWidth: 400,
//   height: 'auto',
//   bgcolor: 'background.paper',
//   border: 'none',
//   boxShadow: 24,
//   borderRadius: '16px',
//   p: { xs: 2, md: 2 },
// };

// const EditArticleModal = ({ open, handleClose, articleData, reloadArticleDetails }) => {
//   const [formData, setFormData] = useState({
//     title: '',
//     author: '',
//     description: '',
//     images: [],
//   });
//   const [isLoading, setIsLoading] = useState(false);
//   const [imageUpload, setImageUpload] = useState(false);

//   // Prefill modal when articleData changes
//   useEffect(() => {
//     if (articleData) {
//       setFormData({
//         title: articleData.title || '',
//         author: articleData.author || '',
//         description:
//           typeof articleData.description === 'string'
//             ? articleData.description
//             : Array.isArray(articleData.description)
//             ? articleData.description.join('\n')
//             : '',
//         images: articleData.images || [],
//       });
//     }
//   }, [articleData]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   // Quill change handler
//   const handleQuillChange = (value) => {
//     setFormData((prev) => ({ ...prev, description: value }));
//   };

//   const handleImageChange = async (e) => {
//     setImageUpload(true);
//     const files = Array.from(e.target.files);

//     try {
//       const uploadedImages = await Promise.all(
//         files.map(async (file) => {
//           const formData = new FormData();
//           formData.append('file', file);
//           formData.append('upload_preset', process.env.REACT_APP_UPLOAD_PRESET);

//           const response = await axios.post(
//             `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
//             formData
//           );
//           return response.data.secure_url;
//         })
//       );

//       setFormData((prev) => ({
//         ...prev,
//         images: [...prev.images, ...uploadedImages],
//       }));
//     } catch (err) {
//       console.error('Error uploading images:', err);
//     }

//     setImageUpload(false);
//   };

//   const handleRemoveImage = (index) => {
//     setFormData((prev) => ({
//       ...prev,
//       images: prev.images.filter((_, i) => i !== index),
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!articleData?._id) return alert('Article ID missing!');
//     setIsLoading(true);

//     const updatedArticleData = {
//       title: formData.title,
//       author: formData.author,
//       description: formData.description, 
//       images: formData.images,
//     };

//     try {
//       await axios.put(
//         `${process.env.REACT_APP_API_URL}/articles/update-articles/${articleData._id}`,
//         updatedArticleData
//       );

//       setIsLoading(false);
//       handleClose();
//       reloadArticleDetails();
//     } catch (error) {
//       console.error('Error updating article:', error.response?.data || error.message);
//       setIsLoading(false);
//     }
//   };

//   return (
//     <Modal open={open} onClose={handleClose}>
//       <Box sx={style}>
//         {imageUpload && (
//           <div className="w-full h-full fixed top-0 left-0 bg-white opacity-75 z-50 flex items-center justify-center">
//             <Loader />
//           </div>
//         )}
//         <div className="h-[80vh] overflow-y-scroll">
//           <Typography id="modal-modal-title" variant="h6" component="h2" className="relative">
//             Edit Article
//             <div
//               onClick={handleClose}
//               className="text-xl absolute top-0 right-2 cursor-pointer text-[#FF8607]"
//             >
//               x
//             </div>
//           </Typography>

//           <form onSubmit={handleSubmit} className="mt-4 px-2">
//             <Grid container spacing={2}>
//               <Grid item xs={12}>
//                 <TextField
//                   label="Title"
//                   name="title"
//                   value={formData.title}
//                   onChange={handleChange}
//                   fullWidth
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField
//                   label="Author"
//                   name="author"
//                   value={formData.author}
//                   onChange={handleChange}
//                   fullWidth
//                   required
//                 />
//               </Grid>

//               {/*  React Quill Editor for Description */}
//               <Grid item xs={12}>
//                 <Typography variant="subtitle1" className="mb-1">
//                   Description
//                 </Typography>
//                 <ReactQuill
//                   theme="snow"
//                   value={formData.description}
//                   onChange={handleQuillChange}
//                   className="bg-white text-black"
//                   modules={{
//                     toolbar: [
//                       [{ header: [1, 2, 3, false] }],
//                       ['bold', 'italic', 'underline', 'strike'],
//                       [{ color: [] }, { background: [] }],
//                       [{ align: [] }],
//                       ['blockquote', 'code-block'],
//                       ['link', 'image'],
//                       ['clean'],
//                     ],
//                   }}
//                   formats={[
//                     'header',
//                     'bold',
//                     'italic',
//                     'underline',
//                     'strike',
//                     'color',
//                     'background',
//                     'align',
//                     'blockquote',
//                     'code-block',
//                     'link',
//                     'image',
//                   ]}
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <label>Choose Images: (500×400 size)</label>
//                 <input
//                   type="file"
//                   accept="image/*"
//                   onChange={handleImageChange}
//                   multiple
//                   style={{ width: '100%' }}
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <Typography variant="h6">Current Images:</Typography>
//                 <div className="grid grid-cols-3 gap-2">
//                   {formData.images.map((image, index) => (
//                     <div key={index}>
//                       <img
//                         src={image}
//                         alt={`img-${index}`}
//                         className="w-full h-20 object-cover rounded"
//                       />
//                       <button
//                         type="button"
//                         onClick={() => handleRemoveImage(index)}
//                         className="text-red-500 mt-1"
//                       >
//                         Remove
//                       </button>
//                     </div>
//                   ))}
//                 </div>
//               </Grid>

//               <Grid item xs={12}>
//                 <button
//                   type="submit"
//                   className="w-full bg-gradient-to-r from-[#FF3131] to-[#ff9301] text-white py-2 rounded-md"
//                   disabled={isLoading}
//                 >
//                   {isLoading ? <Loader /> : 'Save Changes'}
//                 </button>
//               </Grid>
//             </Grid>
//           </form>
//         </div>
//       </Box>
//     </Modal>
//   );
// };

// export default EditArticleModal;


import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import axios from 'axios';
import Loader from '../common/Loader';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import toast from 'react-hot-toast';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 600,
  height: 'auto',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  borderRadius: '16px',
  p: { xs: 2, md: 3 },
};

const EditArticleModal = ({ open, handleClose, articleData, reloadArticleDetails }) => {
  const [formData, setFormData] = useState({
    title: '',
    author: '',
    description: '',
    images: [],
    metaTitle: '',
    metaDescription: '',
    keywords: '',
    canonical: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [imageUpload, setImageUpload] = useState(false);
  const [error, setError] = useState(null);

  // Prefill modal when articleData changes
  useEffect(() => {
    if (articleData) {
      setFormData({
        title: articleData.title || '',
        author: articleData.author || '',
        description: typeof articleData.description === 'string'
          ? articleData.description
          : Array.isArray(articleData.description)
          ? articleData.description.join('')
          : '',
        images: articleData.images || [],
        metaTitle: articleData.metaTitle || '',
        metaDescription: articleData.metaDescription || '',
        keywords: articleData.keywords || '',
        canonical: articleData.canonical || ''
      });
      setError(null);
    }
  }, [articleData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    
    // Auto-generate metaTitle from title if metaTitle is empty
    if (name === 'title' && !formData.metaTitle) {
      setFormData((prev) => ({
        ...prev,
        title: value,
        metaTitle: value ? `${value} | BBSR Services` : ''
      }));
    }
  };

  // Quill change handler
  const handleQuillChange = (value) => {
    setFormData((prev) => ({ ...prev, description: value }));
  };

  const handleImageChange = async (e) => {
    setImageUpload(true);
    setError(null);
    const files = Array.from(e.target.files);

    try {
      const uploadedImages = await Promise.all(
        files.map(async (file) => {
          const formData = new FormData();
          formData.append('file', file);
          formData.append('upload_preset', process.env.REACT_APP_UPLOAD_PRESET);

          const response = await axios.post(
            `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
            formData
          );
          return response.data.secure_url;
        })
      );

      setFormData((prev) => ({
        ...prev,
        images: [...prev.images, ...uploadedImages],
      }));
      toast.success('Images uploaded successfully!');
    } catch (err) {
      console.error('Error uploading images:', err);
      setError('Failed to upload images. Please try again.');
      toast.error('Failed to upload images');
    }

    setImageUpload(false);
  };

  const handleRemoveImage = (index) => {
    setFormData((prev) => ({
      ...prev,
      images: prev.images.filter((_, i) => i !== index),
    }));
    toast.success('Image removed');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    
    if (!articleData?._id) {
      toast.error('Article ID missing!');
      return;
    }

    // Validate required fields
    if (!formData.title.trim()) {
      toast.error('Title is required');
      return;
    }
    if (!formData.author.trim()) {
      toast.error('Author is required');
      return;
    }
    if (!formData.description.trim()) {
      toast.error('Description is required');
      return;
    }
    if (formData.images.length === 0) {
      toast.error('At least one image is required');
      return;
    }

    setIsLoading(true);

    const updatedArticleData = {
      title: formData.title,
      author: formData.author,
      description: formData.description,
      images: formData.images,
      metaTitle: formData.metaTitle || `${formData.title} | BBSR Services`,
      metaDescription: formData.metaDescription || formData.description.substring(0, 160),
      keywords: formData.keywords || '',
      canonical: formData.canonical || `https://www.bbsrservices.co.in/article/${formData.title.toLowerCase().replace(/\s+/g, '-')}`
    };

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/articles/update-articles/${articleData._id}`,
        updatedArticleData
      );

      if (response.data) {
        toast.success('Article updated successfully!');
        setIsLoading(false);
        handleClose();
        if (reloadArticleDetails) {
          reloadArticleDetails();
        }
      }
    } catch (error) {
      console.error('Error updating article:', error.response?.data || error.message);
      const errorMsg = error.response?.data?.message || 'Failed to update article. Please try again.';
      setError(errorMsg);
      toast.error(errorMsg);
      setIsLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        {imageUpload && (
          <div className="fixed inset-0 bg-white bg-opacity-75 z-50 flex flex-col items-center justify-center">
            <Loader />
            <p className="mt-3 text-sm font-medium text-gray-600">Uploading images...</p>
          </div>
        )}

        <div className="max-h-[80vh] overflow-y-auto pr-2">
          <Typography variant="h6" component="h2" className="relative font-bold text-[#1C1C25] mb-4">
            Edit Article
            <div
              onClick={handleClose}
              className="text-2xl absolute top-0 right-0 cursor-pointer text-[#FF8607] hover:text-red-600 transition-colors"
            >
              ×
            </div>
          </Typography>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="mt-2">
            <Grid container spacing={2}>
              {/* Title */}
              <Grid item xs={12}>
                <TextField
                  label="Title *"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  fullWidth
                  required
                  size="small"
                  helperText="This will be used to generate the slug"
                />
              </Grid>

              {/* Author */}
              <Grid item xs={12}>
                <TextField
                  label="Author *"
                  name="author"
                  value={formData.author}
                  onChange={handleChange}
                  fullWidth
                  required
                  size="small"
                />
              </Grid>

              {/* SEO Meta Title */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Meta Title (SEO)"
                  name="metaTitle"
                  value={formData.metaTitle}
                  onChange={handleChange}
                  placeholder="Article Title | BBSR Services"
                  size="small"
                  helperText={`${formData.metaTitle?.length || 0}/60 characters recommended`}
                />
              </Grid>

              {/* SEO Meta Description */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Meta Description (SEO)"
                  name="metaDescription"
                  value={formData.metaDescription}
                  onChange={handleChange}
                  placeholder="Brief description for search engines (150-160 characters)"
                  multiline
                  rows={2}
                  size="small"
                  helperText={`${formData.metaDescription?.length || 0}/160 characters recommended`}
                />
              </Grid>

              {/* SEO Keywords */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Keywords (SEO)"
                  name="keywords"
                  value={formData.keywords}
                  onChange={handleChange}
                  placeholder="article, business, GST, company registration"
                  size="small"
                  helperText="Separate keywords with commas"
                />
              </Grid>

              {/* SEO Canonical URL */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Canonical URL (SEO)"
                  name="canonical"
                  value={formData.canonical}
                  onChange={handleChange}
                  placeholder="https://www.bbsrservices.co.in/article/your-article"
                  size="small"
                />
              </Grid>

              {/* Description - React Quill */}
              <Grid item xs={12}>
                <Typography variant="subtitle2" className="mb-1 font-medium text-gray-700">
                  Description *
                </Typography>
                <ReactQuill
                  theme="snow"
                  value={formData.description}
                  onChange={handleQuillChange}
                  className="bg-white text-black"
                  style={{ height: '150px', marginBottom: '40px' }}
                  modules={{
                    toolbar: [
                      [{ header: [1, 2, 3, false] }],
                      ['bold', 'italic', 'underline', 'strike'],
                      [{ color: [] }, { background: [] }],
                      [{ align: [] }],
                      ['blockquote', 'code-block'],
                      ['link', 'image'],
                      ['clean'],
                    ],
                  }}
                  formats={[
                    'header',
                    'bold',
                    'italic',
                    'underline',
                    'strike',
                    'color',
                    'background',
                    'align',
                    'blockquote',
                    'code-block',
                    'link',
                    'image',
                  ]}
                />
              </Grid>

              {/* Image Upload */}
              <Grid item xs={12}>
                <Typography variant="subtitle2" className="mb-1 font-medium text-gray-700">
                  Choose Images (500×400 size)
                </Typography>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  multiple
                  className="w-full border border-gray-300 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
                />
                <Typography variant="caption" className="text-gray-500">
                  You can select multiple images
                </Typography>
              </Grid>

              {/* Current Images */}
              {formData.images.length > 0 && (
                <Grid item xs={12}>
                  <Typography variant="subtitle2" className="mb-2 font-medium text-gray-700">
                    Current Images ({formData.images.length})
                  </Typography>
                  <div className="grid grid-cols-3 gap-3">
                    {formData.images.map((image, index) => (
                      <div key={index} className="relative group">
                        <img
                          src={image}
                          alt={`Article ${index + 1}`}
                          className="w-full h-24 object-cover rounded-lg border border-gray-200"
                        />
                        <button
                          type="button"
                          onClick={() => handleRemoveImage(index)}
                          className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600 transition-colors opacity-0 group-hover:opacity-100"
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                </Grid>
              )}

              {/* Submit Button */}
              <Grid item xs={12} className="mt-4">
                <button
                  type="submit"
                  className="w-full flex justify-center items-center  bg-gradient-to-r from-[#FF3131] to-[#ff9301] text-white py-2.5 rounded-lg font-semibold hover:opacity-90 transition-opacity disabled:opacity-50"
                  disabled={isLoading}
                >
                  {isLoading ? <Loader /> : 'Save Changes'}
                </button>
              </Grid>
            </Grid>
          </form>
        </div>
      </Box>
    </Modal>
  );
};

export default EditArticleModal;